const initialState = {
  fetching: false,
  fetched: false,
  deleting: false,
  deleted: false,
  saving: false,
  saved: false,
  items: [],
  error: null,
  nbResult: 0,
  paginationPage: 1,
  paginationTotalPages: 1,
  countTopicsByAuthor: 0,
  countTopicsFetching: false,
  countTopicsFetched: false
};
export const topicsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_TOPICS_LIST": {
      return initialState;
    }
    case "UPDATE_TOPIC_STATUS_FULFILLED": {
      const { data } = action.payload.data;
      return {
        ...state,
        items: state.items.map(
          topic =>
            parseInt(topic.id, 10) === parseInt(data.id, 10)
              ? { ...topic, status: data.status }
              : topic
        )
      };
    }
    case "SET_PAGINATION_PAGE": {
      return { ...state, paginationPage: action.pageNumber };
    }
    case "SET_PAGINATION_TOTAL_PAGE": {
      return { ...state, paginationTotalPages: action.totalPages };
    }
    case "FETCH_TOPICS_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_TOPICS_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      let result = data ? data : [];

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: result,
        nbResult: nbResult
      };
    }
    case "FETCH_TOPICS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/topic.js